import Type from 'src/components/gel/Type'
import FormattedText from 'src/components/common/formattedText/FormattedText'

interface TextCommonProps {
  title?: string
  text?: string
  options?: { charLimit?: number; lineLimit?: number }
}

const TextCommon = ({ title, text, options }: TextCommonProps) => (
  <>
    {title && (
      <Type variant="SectionTitleSerif" sx={{ mb: text ? [4, null, 6] : 0 }}>
        {title}
      </Type>
    )}
    {text && (
      <FormattedText
        text={text}
        truncateLength={options?.charLimit}
        typeStyles={{ WebkitLineClamp: options?.lineLimit }}
      />
    )}
  </>
)

export default TextCommon
